(() => {
  const start = () => {
    const banner = document.querySelector('[data-fellaura-cart-timer]');
    if (!banner || banner.dataset.initialized) return;
    banner.dataset.initialized = 'true';
    const clock = banner.querySelector('[data-fellaura-cart-time]');
    const drawer = banner.closest('.js-mini-cart');
    const counter = drawer && drawer.querySelector('.js-cart-count');
    const key = banner.dataset.storageKey;
    const duration = 15 * 60 * 1000;
    let count = Number(banner.dataset.initialCount) || 0;
    let deadline = null;
    let available = true;
    let interval;
    const read = () => {
      try {
        const value = localStorage.getItem(key);
        const parsed = value === null ? null : Number(value);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
      } catch (error) {
        available = false;
        return null;
      }
    };
    const paint = () => {
      const remaining = deadline === null ? 0 : Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      banner.hidden = !available || count === 0 || remaining === 0;
      if (banner.hidden) {
        clearInterval(interval);
        interval = undefined;
        return;
      }
      clock.textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
      if (!interval) interval = setInterval(paint, 1000);
    };
    const sync = () => {
      if (counter) {
        const current = Number(counter.textContent.trim());
        if (Number.isFinite(current)) count = current;
      }
      deadline = read();
      try {
        if (count === 0) {
          localStorage.removeItem(key);
          deadline = null;
        } else if (available && deadline === null) {
          deadline = Date.now() + duration;
          localStorage.setItem(key, String(deadline));
        }
      } catch (error) {
        available = false;
      }
      paint();
    };
    if (counter) new MutationObserver(sync).observe(counter, { childList: true, subtree: true, characterData: true });
    window.addEventListener('storage', event => {
      if (event.key === key) {
        deadline = read();
        paint();
      }
    });
    document.addEventListener('visibilitychange', paint);
    window.addEventListener('pageshow', sync);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
